<template>
    <modal :model-value="!!$route.meta.showModal">
        <div class="w-[90vw] h-[90vh]">
            <router-view name="modal" />
        </div>
    </modal>
    <div class="flex h-screen w-full items-stretch overflow-y-auto">
        <horizontal-resizable-panel :default-width="360" :min-width="200" :max-width="460" storageKey="master_detail">
            <router-view></router-view>
        </horizontal-resizable-panel>
        <div class="flex-auto h-screen overflow-y-auto">
            <router-view name="detail"></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import HorizontalResizablePanel from './HorizontalResizablePanel.vue';
</script>
